<!-- eslint-disable max-len -->
<template>
  <div v-if="!isLoading">
    <RouterView
      v-model="myProfile"
      @update:my-profile="resetFields"
    />
  </div>
  <div
    v-else
    class="min-h-screen bg-gray-100 flex items-center justify-center"
  >
    <div class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-teal-600" />
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  onBeforeMount,
  onUnmounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useUserStore from '@/store/user';

const router = useRouter();
const {
  usersDoGetMyUser,
  resetStore,
} = useUserStore();

/*
  Data
*/
const isLoading = ref(true);
const myProfile = ref({});

/*
  Methods
*/
const redirectDashboard = ((error: string) => router.push({
  name: 'DashboardPage',
  query: {
    message: 'Could not load profile. Please try again.',
    detail: error,
    type: 'error',
  },
}));

const resetFields = async () => {
  isLoading.value = true;
  await usersDoGetMyUser()
    .then((response: any) => {
      if (response === undefined) {
        redirectDashboard('Profile unavailable');
      }
      myProfile.value = response;
      isLoading.value = false;
    }).catch((error: any) => redirectDashboard(error.toString()));
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await resetFields();
});
onUnmounted(() => {
  resetStore();
});
</script>
